<template>
    <div>
        <div class="ix-comments-loader" v-if="loading">
            <i class="far fa-circle-notch fa-spin"></i> Chargement du planning
        </div>


        <div id="intervention-sidebar" class="ix-sidebar ix-sidebar-large"
            v-bind:class="{ 'open': !this.loadingShow && selectedInspection && selectedInspection != null }">
            <div class="ix-sidebar-header">
                <h2 class="ix-sidebar-title"></h2>
                <button class="ix-sidebar-btn-close trigger-close-sidebar">
                    <i class="fal fa-times"></i>
                </button>
            </div>

            <div class="ix-sidebar-content">
                <div class="ix-comments-loader" v-if="loadingShow">
                    <i class="far fa-circle-notch fa-spin"></i> Récupération de la planification
                </div>

                <div v-if="!loadingShow && selectedInspection">
                    <div class="intervention-sidebar-logo" :style="'background:' +selectedInspection.color+ '!important;'">
                        <i class="far fa-wrench"></i>
                    </div>
                 
                    <div class="ix-planning-sidebar-date">
                        Planification du {{ selectedInspection.start_at | formatDate() }} au {{ selectedInspection.end_at |
                            formatDate() }}
                    </div>

                    <div class="ix-planning-sidebar-name text-center" style="font-size: 16px">
                        {{ selectedInspection.name }}
                    </div>

                    <div class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Salariés</h3>
                        <div v-for="(user, index) in selectedInspection.users" :key="index"
                            class="ix-planning-sidebar-users-content mt-2">
                            <span class="ix-avatar sm">
                                <img :src="user.avatar_path" v-if="user.avatar_path">
                                <span v-if="!user.avatar_path">{{ user.initial }}</span>
                            </span>
                            <span class="ix-planning-sidebar-users-content-name">
                                {{ user.fullname }}
                            </span>
                        </div>
                    </div>

                    <div class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Ordre de travaux</h3>
                        <div v-for="(inspection, index) in selectedInspection.inspections" :key="index"
                            class="ix-planning-sidebar-interventions-content">
                            <div style="display: flex; justify-content: space-between">
                                <a class="link" :href="'/gmao/inspections' + '/' + inspection.id">
                                    {{ inspection.number }} - {{ inspection.name }}
                                </a>
                                <span class="ix-state "
                                    v-bind:class="{ 'red': inspection.state == 1, 'yellow': inspection.state == 2, 'blue': inspection.state == 3, 'green': inspection.state == 4 }">
                                    <span v-if="inspection.state == 1">En attente</span>
                                    <span v-if="inspection.state == 2">En cours</span>
                                    <span v-if="inspection.state == 3">Soumis</span>
                                    <span v-if="inspection.state == 4">Fermé</span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="ix-bloc-simple-line">
                        <h3 class="ix-bloc-simple-line-title">Date de création</h3>
                        {{ selectedInspection.created_at | formatDate }}
                    </div>


                    <button type="button" class="ix-btn ix-btn-block transparent mb-2" v-if="selectedInspection.is_editable"
                        @click="editPlanning(selectedInspection)">
                        <i class="far fa-pen"></i> Modifier
                    </button>

                    <button type="button" class="ix-btn ix-btn-block transparent" v-bind:disabled="loadingDelete"
                        v-if="selectedInspection.is_deletable" @click="deletePlanning(selectedInspection)">
                        <span v-if="!loadingDelete"><i class="far fa-trash"></i> Supprimer</span>
                        <span v-if="loadingDelete"><i class="far fa-circle-notch fa-spin"></i> Suppression en cours</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="ix-table-box ix-planning-table-box" v-if="!loading">
            <table class="ix-planning-table">
                <thead>
                    <tr>
                        <th class="ix-planning-table-empty-cell text-center">
                            <a :href="previousUrl" class="ix-absence-table-navigation-button">
                                <i class="far fa-angle-left"></i>
                            </a>
                            <a :href="nextUrl" class="ix-absence-table-navigation-button">
                                <i class="far fa-angle-right"></i>
                            </a>
                        </th>
                        <th v-for="(month, index) in table.months" :key="index" :colspan="month.span"
                            class="ix-planning-cell-month text-center">
                            {{ month.label }} {{ month.year }}
                        </th>
                    </tr>
                    <tr>
                        <th class="ix-planning-table-empty-cell"></th>
                        <th v-for="(week, index) in table.weeks" :colspan="week.span" :key="index"
                            class="ix-planning-cell-week text-center">
                            <span>S{{ week.number }}</span>
                        </th>
                    </tr>
                    <tr>
                        <th class="ix-planning-table-empty-cell"></th>
                        <th v-for="(day, index) in table.days" :key="index" class="ix-planning-cell-day"
                            v-bind:class="{ 'ix-planning-cell-weekend': day.is_weekend, 'ix-planning-cell-not-working': day.is_not_working, 'ix-planning-cell-today': day.is_today }">
                            <span class="ix-triangle-indicator" v-if="day.is_today"></span>
                            {{ day.label[0] }} <br>
                            {{ day.day }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, dataIndex) in table.data" :key="dataIndex" class="ix-planning-cell">
                        <td>
                            {{ row.user.fullname }}
                        </td>
                        <td v-for="(day, dayIndex) in row.days" :key="dayIndex">
                            <div v-if="day.plannings" class="ix-planning-item mt-1" :style="'background:' +planning.color+ '!important;'"
                                v-for="(planning, planningIndex) in day.plannings" :key="planningIndex"
                                @click="openPlanning(planning)" @mouseover="showTooltip(planning)"
                                @mouseout="hideTooltip(planning)">
                                <i class="far fa-wrench"></i>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="table.data.length == 0">
                        <td></td>
                        <td :colspan="table.days.length" class="text-center">Il n'y a pas de salariés sous contrat durant la
                            période demandée</td>
                    </tr>
                </tbody>
            </table>
        </div>


        <button class="d-none" @click="openPostModal()" id="openPlanningModal">new</button>

        <div class="modal fade" id="postPlanningModal" tabindex="-1" aria-labelledby="postPlanningModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ form.id == null ? 'Nouvelle' : 'Modification de la' }} planification</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="identityAutocomplete">Salarié</label>
                                    <div class="ix-table-box">
                                        <table class="ix-table">
                                            <tbody>
                                                <tr v-if="users.length == 0">
                                                    <td colspan="100%">Aucun salarié sélectionné</td>
                                                </tr>
                                                <tr v-for="(user, index) in users" :key="index">
                                                    <td>
                                                        <span class="ix-avatar xsm">
                                                            <img :src="user.avatar_path" v-if="user.avatar_path">
                                                            <span v-if="!user.avatar_path">{{ user.initial }}</span>
                                                        </span>
                                                        {{ user.fullname }}
                                                        <input type="hidden" :name="'users[' + index + '][id]'"
                                                            v-model="user.id">
                                                        <input type="hidden" :name="'users[' + index + '][fullname]'"
                                                            v-model="user.fullname">
                                                        <input type="hidden" :name="'users[' + index + '][avatar_path]'"
                                                            v-model="user.avatar_path">
                                                        <input type="hidden" :name="'users[' + index + '][initial]'"
                                                            v-model="user.initial">
                                                    </td>
                                                    <td class="text-right">
                                                        <button type="button" class="btn btn-sm transparent"
                                                            @click="deleteUserRow(index)">
                                                            <i class="far fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="100%">
                                                        <input
                                                            placeholder="Commencer la saisie pour obtenir des suggestions .."
                                                            class="form-control" id="userSearchInput" type="text"
                                                            v-model="user">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="interventionAutocomplete">Ordre de travaux</label>
                                    <div class="ix-table-box">
                                        <table class="ix-table">
                                            <tbody>
                                                <tr v-if="inspections.length == 0">
                                                    <td colspan="100%">Aucun OT sélectionné</td>
                                                </tr>
                                                <tr v-for="(inspection, index) in inspections" :key="index">
                                                    <td>
                                                        {{ inspection.designation }}
                                                        <input type="hidden" :name="'inspections[' + index + '][id]'"
                                                            v-model="inspection.id">
                                                        <input type="hidden" :name="'inspections[' + index + '][name]'"
                                                            v-model="inspection.name">
                                                    </td>
                                                    <td class="text-right">
                                                        <button type="button" class="btn btn-sm transparent"
                                                            @click="deleteInspectionRow(index)">
                                                            <i class="far fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="100%">
                                                        <input
                                                            placeholder="Commencer la saisie pour obtenir des suggestions .."
                                                            class="form-control" id="inspectionSearchInput" type="text"
                                                            v-model="inspection">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <label for="start_at" class="required">Du :</label>
                                    <v-date-picker v-model="form.start_at" :max-date="maxStartDate" mode="datetime"
                                        :timezone="timezone" is24hr :popover="{ visibility: 'click' }">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <input class="form-control" :value="inputValue" v-on="inputEvents"
                                                required="true" name="start_at" id="start_at" />
                                        </template>
                                    </v-date-picker>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <label for="end_at" class="required">Au : </label>
                                    <v-date-picker v-model="form.end_at" :min-date="minEndDate" mode="datetime"
                                        :timezone="timezone" is24hr :popover="{ visibility: 'click' }">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <input class="form-control" :value="inputValue" v-on="inputEvents"
                                                required="true" name="end_at" id="end_at" />
                                        </template>
                                    </v-date-picker>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="ix-btn green" v-bind:disabled="!checkForm() || loadingForm"
                            @click="post()">
                            <span v-if="!loadingForm">Enregistrer</span>
                            <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";

export default {
    name: "PlanningTable",
    props: ['url', 'usersUrl', 'inspectionsUrl', 'oldData', 'initialData', 'previousUrl', 'nextUrl',],
    data() {
        return {
            loading: true,
            loadingForm: false,
            loadingShow: false,
            loadingDelete: false,
            form: this.fillForm(),
            timezone: '',
            minDate: null,
            users: [],
            user: null,
            inspection: null,
            inspections: [],
            table: {
                days: [],
                weeks: [],
                months: [],
                data: [],
                content: []
            },
            selectedInspection: null,
            showTooltips: []
        }
    },
    computed: {
        minEndDate() {
            if (this.form.start_at) {
                const minDate = new Date(this.form.start_at);
                minDate.setHours(minDate.getHours() + 1);
                return minDate.toISOString();
            }
        },
        maxStartDate() {
            if (this.form.end_at) {
                const maxDate = new Date(this.form.end_at);
                maxDate.setHours(maxDate.getHours() + 1);
                return maxDate.toISOString();
            }
        }
    },
    methods: {
        showTooltip(index) {
            this.$set(this.showTooltips, index.id, true);
        },
        hideTooltip(index) {
            this.$set(this.showTooltips, index.id, false);
        },
        openPlanning: function (planning) {
            this.loadingShow = true;
            this.selectedInspection = null;

            fetch(this.url + '/' + planning.id, {
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    method: "GET",
                }
            }).then((response) => {
                this.loadingShow = false
                if (response.status == 200) {
                    response.json().then((data) => {
                        data.color = planning.color;
                        this.selectedInspection = data
                    })
                } else {
                    this.closePlanningSidebar()
                }
            }).catch(error => {
                this.loadingShow = false
                this.closePlanningSidebar()
                console.log(error);
            })
        },
        editPlanning: function (planning) {
            this.selectedInspection = null;
            this.form = this.fillForm(planning)
            $('#postPlanningModal').modal()
        },
        deletePlanning: function (planning) {
            this.$swal({
                title: "Êtes vous sûr ?",
                text: "La planification sera définitivement supprimée",
                icon: "warning",
                dangerMode: true,
                buttons: ["Annuler", "Supprimer"]
            }).then((willDo) => {
                if (willDo) {
                    this.loadingDelete = true

                    fetch(this.url + "/" + planning.id, {
                        ...{
                            method: 'DELETE'
                        },
                        ...this.getHttpJsonRequestHeaders()
                    }).then(async (response) => {
                        if (response.status == 200) {
                            window.location.reload()
                        } else {
                            this.loadingDelete = false
                        }
                    }).catch(error => {
                        this.loadingDelete = false
                        console.log(error);
                    })

                }
            });
        },
        async getData() {
            this.loading = true;
            fetch(this.url + window.location.search, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loading = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.table.days = data.days
                        this.table.weeks = data.weeks
                        this.table.months = data.months
                        this.table.data = data.data
                        this.types = data.types
                        this.table.content = data.content
                    })
                }
            }).catch(error => {
                this.loading = false;
                console.log(error)
            });
        },
        fillForm(planning = null) {
            this.users = planning ? planning.users : [];
            this.inspections = planning ? planning.inspections : [];

            return {
                id: planning ? planning.id : null,
                description: planning ? planning.description : '',
                start_at: planning ? this.moment(planning.start_at).format() : null,
                end_at: planning ? this.moment(planning.end_at).format() : null,
            }
        },
        openPostModal() {
            this.form = this.fillForm(null)
            $('#postPlanningModal').modal()
        },
        checkForm() {
            return this.form.start_at && this.form.end_at && this.users.length > 0 && this.inspections.length > 0;
        },
        // Users
        addUserRow: function (user) {
            if (this.getCurrentSelectedUsersId().includes(user.id) == false) {
                this.users.push(user)
            }
        },
        deleteUserRow: function (index) {
            this.users.splice(index, 1)
        },

        getCurrentSelectedUsersId: function () {
            return this.users.map(user => user.id);
        },
        // OT
        addInspectionRow: function (inspection) {
            if (this.getCurrentSelectedInspectionsId().includes(inspection.id) == false) {
                this.inspections.push(inspection)
            }
        },
        deleteInspectionRow: function (index) {
            this.inspections.splice(index, 1)
        },
        getCurrentSelectedInspectionsId: function () {
            return this.inspections.map(inspection => inspection.id);
        },
        async post() {
            this.loadingForm = true

            var data = {
                name: 'Test',
                start_at: this.moment(this.form.start_at).format('L LT'),
                end_at: this.moment(this.form.end_at).format('L LT'),
                users: this.users,
                inspections: this.inspections,
            }

            fetch(this.url + (this.form.id ? '/' + this.form.id : ''), {
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    method: this.form.id ? "PUT" : "POST",
                    body: JSON.stringify(data)
                }
            }).then((response) => {
                if (response.ok) {
                    response.json().then((data) => {
                        location.reload()
                    })
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        closePlanningSidebar: function () {
            this.selectedInspection = null
            this.loadingShow = false
            $('#planning-sidebar').removeClass('open');
        },
    },
    async mounted() {
        $("#userSearchInput").autocomplete({
            minLength: 0,
            source: (request, response) => {
                $.ajax({
                    url: this.usersUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term, '!id': this.getCurrentSelectedUsersId().join(';'), 'under_contract': 1 },
                    success: (data) => {
                        response($.map(data, (item) => {
                            return Object.assign(item, {
                                label: item.fullname,
                                value: item.fullname
                            })
                        }))
                    }
                });
            },
            change: (e, item) => {
                if (!item.item) {
                    $(e.target).val("");
                    this.user = null
                }
            },
            select: (e, item) => {
                if (item.item) {
                    this.addUserRow(item.item)
                    $(e.target).val("")
                    this.user = null
                }
            }
        }).focus(() => {
            $("#userSearchInput").autocomplete("search", '');
        });

        $("#inspectionSearchInput").autocomplete({
            minLength: 0,
            source: (request, response) => {
                $.ajax({
                    url: this.inspectionsUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term, '!id': this.getCurrentSelectedInspectionsId().join(';'), "state": 2 },
                    success: (data) => {
                        response($.map(data, (item) => {
                            return Object.assign(item, {
                                label: item.designation,
                                value: item.designation
                            })
                        }))
                    }
                });
            },
            create: function () {
                $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                    var html = `<div class="d-flex align-items-center">
                                    <span class="ml-2">${item.designation}</span>`;

                    html += `<span class="ml-auto badge badge-secondary">   
                                    ${item.equipment.name}
                                    </span>
                                </div>`

                    return $('<li>')
                        .append(html)
                        .appendTo(ul);
                };
            },
            change: (e, item) => {
                if (!item.item) {
                    $(e.target).val("");
                    this.inspection = null
                }
            },
            select: (e, item) => {
                if (item.item) {
                    console.log(item)
                    this.addInspectionRow(item.item)
                    $(e.target).val("")
                    this.inspection = null
                }
            }
        }).focus(() => {
            $("#inspectionSearchInput").autocomplete("search", '');
        });

        const jsonDataBackup = JSON.parse(this.oldData)
        var jsonData = null

        if (Array.isArray(jsonDataBackup)) {
            jsonData = JSON.parse(this.initialData)
        } else {
            jsonData = jsonDataBackup
        }

        if (jsonData.users && Array.isArray(jsonData.users)) {
            jsonData.users.forEach((user) => {
                this.addUserRow(user)
            })
        }

        await this.getData();

        if (jsonData.planning) {
            console.log('test');
            this.openPlanning(jsonData.planning);
        }
    }
}
</script>

<style>
.custom-tooltip {
    position: absolute;
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s, visibility 0.3s;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
}

.ix-planning-item:hover .custom-tooltip {
    visibility: visible;
    opacity: 1;
}

.ix-planning-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.ix-planning-table thead tr th {
    position: sticky;
    top: 0;
    z-index: 1;
}

.ix-planning-cell-week span {
    font-size: 12px;
    font-weight: 500;
    padding: 5px 10px;
    background: var(--ix-background-secondary);
    color: var(--ix-text-secondary);
    display: inline-block;
    border-radius: 5px;
}

.ix-planning-table th,
.ix-planning-table td {
    width: 30px;
    min-width: 30px;
    max-width: 30px;
    border-bottom: 1px solid var(--ix-border-secondary);
    border-right: 1px solid var(--ix-border-secondary);
}

.ix-planning-table tbody tr td:first-child {
    width: 250px;
    min-width: 250px;
    max-width: 250px;
    padding: 5px 10px;
    background: var(--ix-background-secondary);
    color: var(--ix-text-primary);
    font-weight: 500;
}

.ix-planning-cell-day {
    text-align: center;
    text-transform: uppercase;
}

.ix-planning-table thead tr:nth-child(3) th {
    top: 40px;
}

.ix-planning-item {
    position: relative;
    width: 100%;
    height: 25px;
    display: block;
    text-align: center;
    background: #7e004a;
    border-radius: 5px;
    cursor: pointer;
    color: white;
}

.intervention-sidebar-logo {
    width: 100px;
    height: 100px;
    margin: auto;
    border-radius: 10px;
    padding: auto;
    font-size: 30px;
    background: #7e004a;
    text-align: center;
    color: white;
    padding: 25px;
}

.ix-planning-sidebar-date {
    display: block;
    width: 100%;
    text-align: center;
    padding: 5px;
    font-weight: bold;
    font-size: 16px;
}
</style>